module.exports = __webpack_public_path__ + "img/3P.45340e78.png";